import React from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { changePassword } from '../../redux/user.slice';
import { useTranslation } from 'react-i18next';

const ChangePasswordModal = ({ open, onCancel, userId, userName }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const handleChangePassword = () => {
    form
      .validateFields()
      .then((values) => {
        dispatch(changePassword({ id: userId, passwords: values }))
          .unwrap()
          .then(() => {
            message.success(t("profile.password.success"));
            form.resetFields();
            onCancel();
          })
          .catch((err) => {
            message.error(`${t("profile.password.error")}: ${err}`);
          });
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={`${t("profile.password.change")} - ${userName || t("common.name")}`}
      open={open}
      onCancel={handleCancel}
      footer={null}
      destroyOnHidden
    >
      <Form form={form} layout="vertical" name="change_password_form">
        <Form.Item
          name="oldPassword"
          label={t("profile.password.oldPassword")}
          rules={[{ required: true, message: t("profile.validation.oldPassword") }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label={t("profile.password.newPassword")}
          rules={[{ required: true, message: t("profile.validation.newPassword") }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="confirmNewPassword"
          label={t("profile.password.confirmPassword")}
          dependencies={['newPassword']}
          rules={[
            { required: true, message: t("profile.validation.confirmPassword") },
            ({
              getFieldValue,
            }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t("profile.validation.passwordMatch")));
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>
        <div className="d-flex flex-row-reverse gap-3">
          <Button type="primary" onClick={handleChangePassword}>
            {t("profile.password.change")}
          </Button>
          {/* <Button className="secondary-button" onClick={handleCancel}>
            Annuler
          </Button> */}
        </div>
      </Form>
    </Modal>
  );
};

ChangePasswordModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  userId: PropTypes.number,
  userName: PropTypes.string,
};

export default ChangePasswordModal;